<template>
  <b-container class="vertical-center">
    <mdb-container class="profile-container container">
      <mdb-row>
        <mdb-col>
          <div class="row">
            <div class="col-md-6">
              <label>User</label>
            </div>
            <div class="col-md-6">
              <p>{{ user.user }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>Name</label>
            </div>
            <div class="col-md-6">
              <p>{{ user.user }}</p>
            </div>
          </div>

          <h1>COMING SOON</h1>
          <div class="row">

            <div v-if="!user.isBlocked">
              <b-row>
                <b-col v-if="user.user==='branchofapp' || user.user==='driven'" cols="8">
                  <YourSynchronicityExtension key="facebook" social-media="facebook"/>
                </b-col>

              </b-row>
            </div>
          </div>
            <div v-if="user.isBlocked" class="row">

              <div class="col-md-6">
                <label>Your account is blocked, please enter the License key to unlock Your
                  Synchronicity,
                  and start
                  joining the dots</label>
              </div>
              <div class="col-md-6">
                <p>
                  <input v-model="unlockCode" placeholder="License Key">
                  <button v-on:click="unlockAccount">Unlock Me</button>
                </p>
              </div>

              <div class="col-md-6"><br><br>
                <card>
                  <label>Your Referrer is {{ actualReferrer }}, not sure ? change it</label>

                  <p>
                    <input v-model="newYsyReferrer" placeholder="Your new referrer">
                    <button v-on:click="changeReferrerYsy">Change</button>
                  </p>
                </card>
              </div>

            </div>
            <div>
              <!-- Central Modal Medium Success -->
              <mdb-modal :show="show" @close="show = false" success>
                <mdb-modal-header v-bind:color=this.conf.headerColor>
                  <mdb-modal-title>{{ this.conf.title }}</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body class="text-center">
                  <mdb-icon v-bind:icon=this.conf.icon v-bind:color=this.conf.color size="4x"
                            class="mb-3 animated rotateIn"/>
                  <p>{{ this.conf.welcome }}</p>
                </mdb-modal-body>
                <mdb-modal-footer center>
                  <mdb-btn v-bind:color=this.conf.color @click="show = false" v-on:click="navigate">
                    {{ this.conf.response }}
                    <mdb-icon icon="thumbs-up" far class="ml-1" color="white"/>
                  </mdb-btn>
                </mdb-modal-footer>
              </mdb-modal>
              <mdb-modal :show="showModalClearWithdraw" @close="showModalClearWithdraw = false">
                <mdb-modal-header>
                  <mdb-modal-title>Confirm the withdrawal</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>Confirm please if you want to withdraw from your account all the
                  invitation that are still
                  pending for more than {{ requestPeriodSelected }}, Once the process finished we will
                  send you an Email
                  notification with
                  attachment the deleted users
                </mdb-modal-body>
                <mdb-modal-footer>
                  <mdb-btn color="secondary" @click.native="showModalClearWithdraw = false">Close
                  </mdb-btn>

                </mdb-modal-footer>
              </mdb-modal>
            </div>

        </mdb-col>
      </mdb-row>
    </mdb-container>
  </b-container>

</template>

<script>
import {
  mdbContainer, mdbCol
} from "mdbvue";
import {
  mdbRow,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTooltip
} from 'mdbvue';
import router from '../../router'
import VueLoadingButton from 'vue-loading-button';

import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
import {eventBus} from '../../main'

import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {refreshIdToken} from '../../util/utilsYsy'
import YourSynchronicityExtension from "@/components/YourSynchronicityExtension";

Vue.component(VueCountdown.name, VueCountdown);

const redDict = {
  headerColor: 'red',
  title: 'Wrong License',
  color: 'Warning',
  icon: 'times-circle',
  welcome: 'Unfortunately, It is not the correct license please contact your administrator.',
  response: 'Got it'
};
const greenDict = {
  title: 'Correct License',
  color: 'success',
  icon: 'check',
  welcome: 'Congratulation, You have successfully activated your account, you are now surrounded by signs, coincidences, and synchronicities , all aimed at propelling you in the direction of your success.',
  response: 'Start your synchronicity'
};
export default {
  name: 'YsyProfile',
  components: {
    YourSynchronicityExtension,
    VueLoadingButton,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTooltip,
    mdbContainer, mdbRow,
    mdbCol,
    eventBus
  },
  data() {
    return {

      user: '',
      mapAutomatedActionYsy: {
        withdraw_users: "Withdraw users that are more than 2 weeks old",
        like_posts: "Like randomly posts that appear in your feed",
        endorse_users: "Endorse randomly people that are in your network"
      },
      mapNotificationActionYsy: {
        notify_end_configuration: "Receive notification when configuration finish",
        notify_withdraw_users: "Receive notification when withdraw users",
      },
      actualReferrer: '',
      dictConfigurationLimit: '',
      dictConfigurationLimitStatus: false,
      state_connection: '',
      state_message: '',
      automatedYsyActions: [],
      notificationActionYsy: [],
      state_get_contact_information: '',
      unlockCode: '',
      newYsyReferrer: '',
      conf: '',
      deltaAnalysisRunAllowed: 5,
      lastWithdrawRun: '',
      deltaWithdrawRun: '',
      deltaWithdrawRunDate: '',
      isLoadingButton: false,
      show: false,
      showModalClearWithdraw: false,
      pendingRequest: 0,
      counting: false,
      requestPeriodSelected: '1 month ago',
      update_key_switch: '',
      update_key_switch_notify: ''
    };
  },
  created() {
    console.log('ooooook')
    if ("code" in this.$route.query && "location" in this.$route.query && "accounts-server" in this.$route.query) {
      this.check_zoho_integration(this.$route.query.code, this.$route.query.location, this.$route.query["accounts-server"])
    }
    this.user = this.$store.getters.getStateLinkedin;
    this.automatedYsyActions = this.$store.getters.getAutomatedYsyActions;
    this.notificationActionYsy = this.$store.getters.getNotificationActionYsy;
    this.actualReferrer = this.$store.getters.getReferrer;
    if (this.user.haveAccount) {
      // console.log('999999999',localStorage.dictConfigurationLimit)
      this.dictConfigurationLimit = this.user.dictConfigurationLimit

      this.setConfigurationLimit()
      this.lastWithdrawRun = this.user.lastWithdrawRun
      console.log(this.lastWithdrawRun)
      var difference = Math.floor(Date.now() / 1000) - parseInt(this.lastWithdrawRun);
      var countDownDifference = new Date(parseInt(this.lastWithdrawRun) * 1000)
      var numberDaysToAdd = this.deltaAnalysisRunAllowed
      countDownDifference.setDate(countDownDifference.getDate() + numberDaysToAdd);
      console.log(countDownDifference)
      this.deltaWithdrawRun = Math.floor(difference / 60 / 60 / 24);
      console.log(new Date())
      this.deltaWithdrawRunDate = countDownDifference - new Date();
      console.log(this.deltaWithdrawRunDate)

      this.getPendingRequest()

      console.log(this.user)
      this.conf = redDict
      this.startCountdown()
    }

  },
  methods: {

    refreshIdToken,
    go_to_crm_zoho_integration() {
      const client_zoho_id = "1000.VMV4CDVC4MECT0INZSRR2SIT1TQBVR";
      const redirect_zoho_uri = "https://www.yoursynchronicity.com/linkedin/profile";
      window.location.href = `https://accounts.zoho.com/oauth/v2/auth?response_type=code&client_id=${client_zoho_id}&scope=ZohoCRM.org.Read,ZohoCRM.modules.leads.ALL&redirect_uri=${redirect_zoho_uri}&prompt=consent&access_type=offline`
    },
    check_zoho_integration(code, location, accounts_server) {
      const path = this.BACKEND_YSY + "/ysy-crm-integration";
      this.$http
        .post(path, JSON.stringify({
          username: this.$store.getters.getUser,
          crm: 'zoho',
          crm_dict: {code, location, accounts_server}
        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res)
          localStorage.CrmToken = JSON.stringify(res.data.body['zoho']);
          this.$notify({
            message:
              '<b>Congratulations CRM added successfully</b>',
            timeout: 5000,
            icon: 'ni ni-bell-55',
            type: "success"
          })
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.$router.push({name: 'login'});
        });

    },
    check_automated_ysy_actions(event, action) {
      if (event === 'Off') {
        this.$store.commit('popAutomatedAction', action)
      }
      if (event === 'On') {
        this.$store.commit('pushAutomatedAction', action)
      }
      this.automatedYsyActions = this.$store.getters.getAutomatedYsyActions;
      const path = this.BACKEND_YSY + "/linkedin/action-on-user";
      this.$http
        .post(path, JSON.stringify({
          username: this.$store.getters.getUser,
          action: 'control_automated_actions',
          activate_ysy_actions: this.automatedYsyActions
        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.$router.push({name: 'login'});
        });
      this.update_key_switch = Date.now();
    },
    check_notification_ysy_actions(event, action) {
      if (event === 'Off') {
        this.$store.commit('popNotificationActionYsy', action)
      }
      if (event === 'On') {
        this.$store.commit('pushNotificationActionYsy', action)
      }
      this.notificationActionYsy = this.$store.getters.getNotificationActionYsy;
      const path = this.BACKEND_YSY + "/action-on-user";
      this.$http
        .post(path, JSON.stringify({
          username: this.$store.getters.getUser,
          action: 'control_notification_actions',
          activate_ysy_actions: this.notificationActionYsy
        }), {
          headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${localStorage.id_token}`
          }
        })
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.$router.push({name: 'login'});
        });
      this.update_key_switch_notify = Date.now();
    },
    changeLinkedInCredentials() {
      this.$store.commit('setUnlinkLinkedIn', true);
      this.$router.push({name: 'Set LinkedIn configuration'});
    },
    setConfigurationLimit() {
      var dictConfigurationLimit = this.dictConfigurationLimit;
      if (dictConfigurationLimit['connection']['count'] >= dictConfigurationLimit['connection']['limit']) {
        this.state_connection = 'led-red';
      } else {
        this.state_connection = 'led-green';
      }
      if (dictConfigurationLimit['message']['count'] >= dictConfigurationLimit['message']['limit']) {
        this.state_message = 'led-red';
      } else {
        this.state_message = 'led-green';
      }
      if (dictConfigurationLimit['getContactInformation']['count'] === 1) {
        this.state_get_contact_information = 'led-yellow';
      } else if (dictConfigurationLimit['getContactInformation']['count'] > dictConfigurationLimit['getContactInformation']['limit']) {
        this.state_get_contact_information = 'led-red';
      } else {
        this.state_get_contact_information = 'led-green';
      }
      this.dictConfigurationLimitStatus = true
    },
    startCountdown: function () {
      this.counting = true;
    },
    handleCountdownEnd: function () {
      this.counting = false;
    },

    onChildClick(value) {
      console.log(value);
    },
    getPendingRequest() {
      if (!localStorage.pendingRequest) {
        console.log('loading the data in local store');
        const path = this.BACKEND_YSY + "/linkedin/get-user-configuration";
        let headers = {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.id_token}`
        };
        this.$http
          .post(path, {
            ysy_username: this.$store.getters.getUser,
            email_linkedin: this.$store.getters.getEmailLinkedin,
            withdrawCount: "True"
          }, {headers})
          .then(res => {
            console.log("res", res);
            this.pendingRequest = res.data.count;
            localStorage.pendingRequest = this.pendingRequest
          })
          .catch(error => {
            // eslint-disable-next-line
            console.error(error);
            this.$router.push({name: 'login'});
          });
      } else {
        console.log('No need for axios - Data in local store')
        this.pendingRequest = localStorage.pendingRequest
      }
    },
    navigate() {
      this.$router.push({name: "set-user-configuration"});
    },
    async changeReferrerYsy() {
      if (this.newYsyReferrer === "") {
        swal.fire({
          title: `Please put a referrer`,
          text: 'Unfortunately, you can\'t set an empty referrer',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          icon: 'warning'
        });
        // this.show = true;
        return 'ok'
      }
      const path = this.BACKEND_YSY + "/action-on-user";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      await this.$http
        .post(path, {
          username: this.user.user,
          new_ysy_referrer: this.newYsyReferrer.toUpperCase(),
          action: 'change_ysy_referrer'
        }, {headers})
        .then(res => {
          console.log(res);
          if (res.data === 200) {
            swal.fire({
              title: `Referrer changed`,
              html:
                '<p>Congratulation, Your referrer has been changed </p>',
              icon: 'success'
            });
          }
          this.actualReferrer = this.newYsyReferrer.toUpperCase();
          this.$store.commit('setReferrer', this.actualReferrer);
          this.newYsyReferrer = ''
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.changeReferrerYsy()
            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });

          }
        });
    },
    unlockAccount() {
      if (this.unlockCode === "") {
        swal.fire({
          title: `Wrong License`,
          text: 'Unfortunately, It is not the correct license please contact your administrator.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          icon: 'warning'
        });
        return 'ok'
      }
      const path = this.BACKEND_YSY + "/unlock-account";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      this.$http
        .post(path, {
          username: this.user.user,
          unlock_code: this.unlockCode,
        }, {headers})
        .then(res => {
          console.log(res);
          if (res.data === '200') {
            this.$store.commit('unlock_account');
            swal.fire({
              title: `Correct License`,
              html:
                '<p>Congratulation, You have successfully activated your account, you are now surrounded by signs' +
                ',coincidences, and synchronicities , all aimed at propelling you in the direction of your success. </p>',
              confirmButtonText: 'Start your synchronicity',
              confirmButtonClass: 'btn btn-warning',
              icon: 'success'
            });
            this.$router.push({name: "Dashboard"});
          } else {
            swal.fire({
              title: `Wrong License`,
              text: 'Unfortunately, It is not the correct license please contact your administrator.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-warning',
              icon: 'warning'
            });
          }

        })
        .catch(error => {
          // eslint-disable-next-line
          console.error('Unauthorized', error.response.data);
          this.$router.push({name: "login"});
        });

    }
  },


}

</script>

<style scoped>
@import '../../assets/css/yoursynchronicityCSSlib';

</style>
